import React, {useCallback, useEffect, useState} from "react";
import QTextBox from "../../../../common/components/QTextBox";
import QSelect from "../../../../common/components/QSelect";
import UserApi from "../../../../common/api/functions/User";
import SetupApi from "../../../../common/api/functions/Setup";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {LayoutInterface, PaymentTermInterface, ProductInterface, VatZoneInterface} from "../../../../interfaces/economic/CommonInterface";
import {SelectOptionInterface} from "../../../../interfaces/SelectOptionInterface";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../../app/store";
import {setLoading} from "../../../../app/rootReducer";
import {Progress, Spinner} from "reactstrap";
import QSelectSearch from "../../../../common/components/QSelectSearch";
import {handleInputChange} from "react-select/dist/declarations/src/utils";
import { debounce } from "lodash"
import {useTranslation} from "react-i18next";

interface Props {
    formik: any
}

const Invoice: React.FC<Props> = ({formik}) => {
    const {t} = useTranslation();
    const [layouts,setLayouts] = useState<LayoutInterface[]>([]);
    const [paymentTerms,setPaymentTerms] = useState<PaymentTermInterface[]>([]);
    const [bookedWiths,setBookedWiths] = useState({});
    const [otherRef,setOtherRef] = useState({});
    const [invoiceSources,setInvoiceSources] = useState({
        invoice: 'Stripe Invoice',
        checkout: 'Stripe Checkout',
    });
    const [vatZones, setVatZones] = useState<VatZoneInterface[]>([]);
    const [products, setProducts] = useState<ProductInterface[]>([]);
    const [loadingProduct, setLoadingProduct] = useState(true);
    // const [layouts,setLayouts] = useState<LayoutInterface[]>([]);
    const {loading} = useSelector((state:RootState) => state.rootReducer);
    const dispatch = useDispatch();



    useEffect(()=>{
        console.log('loading',loading);
        if(loading){
            SetupApi.getDataSetupInvoice().then(async (response: ResponseInterface | any)=>{
                let {layouts,paymentTerms,bookedWiths,otherRef,invoiceSources,vatZones} = response?.data?.data;
                setLayouts(layouts);
                setPaymentTerms(paymentTerms);
                setBookedWiths(bookedWiths);
                setOtherRef(otherRef);
                if (invoiceSources) {
                    setInvoiceSources(invoiceSources);
                }
                setVatZones(vatZones || []);
                dispatch(setLoading(false));
            })

        }
    },[loading]);


    const searchProduct = useCallback(debounce((inputValue:string) => {
        console.log(inputValue);
        return SetupApi.searchProduct(inputValue).then(async (response: ResponseInterface | any)=>{
            return response?.data?.data?.map((item:ProductInterface) => ({
                label:item.name,
                value:item.productNumber,
            }));
        });
    },300),[]);


    const promiseOptions = useCallback(debounce((e:string,callback) => {
        const controller = new AbortController();
        if(e.length > 1){
            SetupApi.searchProduct(e).then(async (response: ResponseInterface | any)=> {
                return response?.data?.data?.map((item: ProductInterface) => ({
                    label: item.productNumber + ' - ' + item.name,
                    value: item.productNumber,
                }))
            }).then(results => {
                callback(results);
            });
        }else{
            callback(null);
        }

        return () => controller.abort();
    },500),[]);


    // console.log(formik.errors);
    return(
        <React.Fragment>

            <QSelect
                label={t("economic.invoiceSource")}
                value={formik.values.stripe_invoice_source}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('stripe_invoice_source',option.value);
                }}
                options={Object.entries(invoiceSources).map(([key, value]) => ({
                    label:value,
                    value:key,
                }))}
                error={formik.errors?.stripe_invoice_source}
            />
            <h6 className="mt-3">{t("economic.vatZones")}</h6>
            {[
                ['economic_invoice_vat_zone_domestic_number', 'economic.vatZoneDomestic'],
                ['economic_invoice_vat_zone_eu_number', 'economic.vatZoneEu'],
                ['economic_invoice_vat_zone_abroad_number', 'economic.vatZoneAbroad'],
                ['economic_invoice_vat_zone_domestic_without_vat_number', 'economic.vatZoneDomesticWithoutVat'],
            ].map(([field, label]) => (
                <QSelect
                    key={field}
                    label={t(label)}
                    value={formik.values[field]}
                    onChange={(option: SelectOptionInterface) => {
                        formik.setFieldValue(field, option.value);
                    }}
                    options={vatZones.map((zone: VatZoneInterface) => ({
                        label: zone.name,
                        value: zone.vatZoneNumber,
                    }))}
                    error={formik.errors?.[field]}
                />
            ))}
            <QSelect
                label={'Layout'}
                value={formik.values.economic_invoice_layout_number}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('economic_invoice_layout_number',option.value);
                }}
                options={layouts.map((a:LayoutInterface)=>({label:a.name,value:a.layoutNumber}))}
                error={formik.errors?.economic_invoice_layout_number}
            />
            <QSelect
                label={'Payment Term'}
                value={formik.values.economic_invoice_payment_terms_number}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('economic_invoice_payment_terms_number',option.value);
                }}
                options={paymentTerms.map((a:PaymentTermInterface)=>({label:a.name,value:a.paymentTermsNumber}))}
                error={formik.errors?.economic_invoice_payment_terms_number}
            />

            <QSelect
                label={'Booked with'}
                value={formik.values.economic_invoice_booked_with}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('economic_invoice_booked_with',option.value);
                }}
                options={Object.entries(bookedWiths).map(([key, value]) => ({label:value,value:key}))}
                error={formik.errors?.economic_invoice_booked_with}
            />

            <QSelect
                label={'Other reference'}
                value={formik.values.economic_invoice_other_ref}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('economic_invoice_other_ref',option.value);
                }}
                options={Object.entries(otherRef).map(([key, value]) => ({label:value,value:key}))}
                error={formik.errors?.economic_invoice_other_ref}
            />
            <QSelectSearch
                label={'Product discount'}
                value={formik.values.economic_invoice_product_discount_number}
                onChange={(option:SelectOptionInterface) => {
                    formik.setFieldValue('economic_invoice_product_discount_number',option.value);
                }}
                error={formik.errors?.economic_invoice_product_discount_number}
                placeholder={'Fill in product number using for discount'}
                promiseOptions={promiseOptions}
            />

        </React.Fragment>
    )
}

export default Invoice;
